import { gql } from '@apollo/client';

export const CampaignLeadListsQuery = gql`
  query CampaignLeadLists($campaignId: ID!) {
    campaign(id: $campaignId) {
      id
      leadLists {
        createdAt
        originalFilename
        id
        leadCount
        sentToCampaignTimestamp
        status
      }
    }
  }
`;
